export default __webpack_public_path__ + "static/media/The Baleful Blade.a98db3c0.jpg";